/**
 * @file isFixed
 * @author yuzong(yuzong@tencent.com)
 */
import { isClient } from '@tencent/glue-util-boundary';
export function isFixed(element) {
  if (!isClient()) {
    return false;
  }

  if (element === document.body) {
    return false;
  }

  if (window.getComputedStyle(element).position === 'fixed') {
    return true;
  }

  return element.parentNode ? isFixed(element.parentNode) : false;
}